import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { setCateCd, setPdtCate } from '@app/actions/shoppingmall/product.action';
import { AuthUtil } from '@app/common/util/auth.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { PdtCateModel } from '@app/models/shoppingmall/pdt-cate.model';
import { PdtCateState, getPdtCates } from '@app/selectors/shoppingmall/pdt-cate.selector';
import { ProductState } from '@app/selectors/shoppingmall/product.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'hp-product',
  templateUrl: './hp-product.component.html',
  styleUrls: ['./hp-product.component.css']
})
export class HpProductComponent implements OnInit {

  pdtCates$ = new Observable<PdtCateModel[]>();
  cates: PdtCateModel[] = [];
  active:string = "0111";
  chkMemEdu: string = "N";

  constructor(private _pdtCateStore: Store<PdtCateState>,private _http: HttpClient,
    private __productStore: Store<ProductState>
  ) {

    this.pdtCates$ = this._pdtCateStore.select(getPdtCates);
  }

  ngOnInit(): void {
    this.__productStore.dispatch(setCateCd({ cateCd: "" }));
    this._http.get(`${environment.apiUrl}/product/chkMemEdu?comId=${environment.comId}&userid=${AuthUtil.getLoginedInfo()?.userid}`, { responseType: 'text' }).subscribe((response: string) => {

      this.chkMemEdu = response;

    }, (error) => {
      console.error(error);
    })


    this.pdtCates$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)){
        this.cates = res.filter((y) => y.lv == '2');
      }
    });
  }

  clickItemCate(cateCd:String){
    this.active = String(cateCd);
  }

}
